$ = require 'jquery'
_ = require 'underscore'
Language = require('@trello/locale')
Session = require '@trello/session-cookie'

module.exports = new class
  idNotLoggedIn = 'notLoggedIn'
  memberId = Session.memberId or idNotLoggedIn

  isLoggedIn: -> memberId != idNotLoggedIn
  myId:       -> memberId
  myUsername: -> @me()?.get('username')
  myToken:    -> Session.token
  myLocale:   ->
   # Server doesn't do validation on locales so we can't trust this has been
   # normalized already i.e. it could be ja_jp when we generally want ja-jp
   locale = @me()?.get('prefs')?.locale
   if locale then Language.normalizeLocale(locale) else locale
  me:         ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    me = ModelCache.get('Member', memberId)
    if !me? && !@isLoggedIn()
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      Member = require 'app/scripts/models/member'
      me = new Member({ id: idNotLoggedIn, notLoggedIn: true }, { modelCache: ModelCache })
      ModelCache.add(me)
    me
  # Returns true if the member or member id passed in is the logged in member
  isMe: (memberOrId) ->
    if (memberOrId?.id)
      @isMe(memberOrId.id)
    else
      memberOrId == memberId

  confirmed: ->
    return @me().get('confirmed')

  canLogIn: ->
    return !_.isEmpty(@me()?.get('loginTypes') ? [])

  logoutPost: (returnUrl) ->
    $form = $('<form>')
    .attr({ method: 'post', action: '/logout' })
    .css({ display: 'none' })

    $dscInput = $('<input>')
    .attr('name', 'dsc')
    .val($.cookie('dsc'))

    $form.append($dscInput)

    if returnUrl?
      $returnUrlInput = $('<input>')
      .attr('name', 'returnUrl')
      .val(returnUrl)

      $form.append($returnUrlInput)

    # A cookie alone is not enough, because that leaves us
    # vulnerable to CSRF.
    $form
    .appendTo('body')
    .submit()

  removeToken: ->
    Session.clearCookie()
    window.location.reload()
